import packageInformation from '../../package.json'

/** The packageDetails object has a get function that extracts fable package
 * name and version to be used in the `dataPkgId` prop of components */
export const packageDetails = {
  get: () => `${packageInformation.name}-${packageInformation.version}`
}
